import * as React from 'react'
import { DAYS_OF_WEEK } from '../../../../state/constants/index'
import { IWorkingHoursItem } from '../../../../types/index'
import TrashIcon from '../../../icons/ui/Trash'
import ContextMenu from '../../../ui/ContextMenu'
import WorkingTime from '../WorkingTime'
import DaysOfWeek from './DaysOfWeek'

interface IServiceWorkingHoursItemProps {
  workingHoursItem: IWorkingHoursItem
  onRemoveClick: (id: string) => void
  onSetFrom: (workingHoursId: string, from: string) => void
  onSetUntil: (workingHoursId: string, until: string) => void
  onSetDays: (workingHoursId: string, days: string[]) => void
}

const ServiceWorkingHoursItem = (props: IServiceWorkingHoursItemProps) => {
  const {
    workingHoursItem,
    workingHoursItem: { id, days, from, until },
    onRemoveClick,
    onSetDays,
    onSetFrom,
    onSetUntil
  } = props

  const removeDay = (days: DAYS_OF_WEEK[], day: DAYS_OF_WEEK): DAYS_OF_WEEK[] => {
    const position = days.indexOf(day)
    return [...days.slice(0, position), ...days.slice(position + 1)]
  }

  const addDay = (days: DAYS_OF_WEEK[], day: DAYS_OF_WEEK): DAYS_OF_WEEK[] => {
    return [...days, day]
  }

  const handleDayClick = (day: DAYS_OF_WEEK) => {
    const updatedDays = days.includes(day) ? removeDay(days, day) : addDay(days, day)
    onSetDays(id, updatedDays)
  }

  const handleTimeSet = (type: string, time: string) => {
    type === 'from' ? onSetFrom(id, time) : onSetUntil(id, time)
  }

  const handleRemoveClick = () => {
    onRemoveClick(id)
  }

  return (
    <div className='mt3'>
      <div className='flex flex-row items-start' style={{ columnGap: '15px' }}>
        <div>
          <div className='h5 font-dark-grey'>From - Until</div>
          <div className='full-width-datepicker'>
            <WorkingTime from={from} type='long' until={until} onTimeSet={handleTimeSet} />
          </div>
        </div>
        <div>
          <div className='h5 font-dark-grey'>On these days</div>
          <div className='mt02 full-width-datepicker'>
            <DaysOfWeek days={workingHoursItem.days} id={workingHoursItem.id} onDayClick={handleDayClick} />
          </div>
        </div>
        <div className='mt1 pt2 self-center'>
          <ContextMenu>
            <div className='MenuItem flex items-center cursor--pointer p1' onClick={handleRemoveClick}>
              <TrashIcon className='icon--22x22 svg-stroke-grey3 mr1' />
              <span className='font-dark-grey'>Remove</span>
            </div>
          </ContextMenu>
        </div>
      </div>
    </div>
  )
}

export default ServiceWorkingHoursItem



// WEBPACK FOOTER //
// ./src/components/services/edit/working-hours/ServiceWorkingHoursItem.tsx